/** page/formulas 文件 对应的文件名称 */
import storage from 'storejs'
import store from './../store'


/** 根据 category文件夹的数据，合并成所有的目录集合 */
const modulesFiles = require.context('./category', true, /\.js$/)
let pageCategoryList = {} // 所有公式详情页的集合
let pageNotHaveInfoList = {}  // 没有介绍的公式的集合
let menuList = [] // 所有分类的明细集合
let menuMap = {
  'ObGyn':'产科学',
  'ID':'传染病',
  'Pedi':'儿科学',
  'Trauma':'创伤医学',
  'Pulm':'呼吸病学',
  'EBM':'循证医学',
  'Card':'心血管病学',
  'ER':'急诊室 - ICU',
  'Nurse':'护理学',
  'Elec':'电解质',
  'Neuro':'神经病学',
  'Diab':'糖尿病',
  'Renal':'肾脏病学',
  'Onco':'肿瘤学',
  'GIT':'胃肠消化病学',
  'Anae':'麻醉学',
  'Hepatology':'肝脏病学',
  'RI':'风湿免疫学',
  'Hema':'血液病学',
  'Urology':'泌尿外科学',
  'Hepatology':'肝脏病学'
}
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  moduleName.indexOf('/') !== -1 ? moduleName = moduleName.split('/')[1] : ''
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  // console.log(moduleName);
  let val = value.default
  if (val.categoryMap) {
    let menuObj = {
      type: moduleName,
      name: val.categoryMap,
      desc: val.categoryDescMap
    }
    menuList.push(menuObj)  
  }
  if (val.categoryNotInfoMap) {
    pageNotHaveInfoList =  Object.assign({},pageNotHaveInfoList, val.categoryNotInfoMap )
  }
  
  pageCategoryList = Object.assign({},pageCategoryList, val.categoryMap )
  // console.log('pageCategoryList',pageCategoryList);
  return modules
}, {})
// console.log(modules);
// console.log(menuList);
// console.log(pageCategoryList);
// console.log('pageNotHaveInfoList',pageNotHaveInfoList);
storage('yszFormulaMenu',JSON.stringify(pageCategoryList))
store.commit('setFormulaMenuList',pageCategoryList)
store.commit('setFormulaNotInfoPageList',pageNotHaveInfoList)




export const pageCategory = {
  ...pageCategoryList
}

/* export const pageListArray = {
  
  'ObGyn':{ // 产科学

  },
  'ID':{ // 传染病

  },
  'Pedi':{ // 儿科学

  },
  'Trauma':{ // 创伤医学

  },
  'Pulm':{ // 呼吸病学

  },
  'EBM':{ // 循证医学

  },
  'Card':{ // 心血管病学

  },
  'ER':{ // 急诊室 - ICU

  },
  'Nurse':{ // 护理学

  },
  'Elec':{ // 电解质

  },
  'Neuro':{ // 神经病学

  },
  'Diab':{ // 糖尿病

  },
  'Renal':{ // 肾脏病学

  },
  'Onco':{ // 肿瘤学

  },
  'GIT':{ // 胃肠消化病学

  },
  'Anae':{ // 麻醉学

  },

} */


// WEBPACK FOOTER //
// ./src/utils/pageCategory.js